(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyUiSelectChoicesScrollTop", ['$timeout', function ($timeout) {
    return {
      restrict: "A",
      require: "uiSelect",
      scope: true,
      link: function ($scope, $element, $attrs, $select) {


        $timeout(function () {
          var uiChoice = $element.find('#selectedTopic');
          $scope.scrollTopOnClose = function (isOpen) {
            if (!isOpen && uiChoice.length > 0) {
              uiChoice[0].scrollTop = 0;
            }
          };

          $scope.$watch(function () {
            return $select.open;
          }, function (newVal) {
            $scope.scrollTopOnClose(newVal);
          });

        });

      },
    };
  }]);
})(window.angular);

